const headers = {
    NETOAPI_ACTION: "GetCategory",
    NETOAPI_USERNAME: "api",
    NETOAPI_KEY: "mZnCZtD5uzvhCiefpVpJHyFSeznm5E6s",
};

export default headers

